import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Language } from '@app/shared/models/language.model';
import { WindowRefService } from '@core/services/helpers/window-ref.service';
import { BehaviorSubject, Observable } from 'rxjs';
import moment from 'moment';

@Injectable()
export class InternationalizationService {
    get languages(): Language[] {
        return this._languages;
    }

    get currentLanguage(): Observable<Language> {
        return this.currentLanguageSubject.asObservable();
    }

    private window: Window;
    private currentLanguageSubject: BehaviorSubject<Language>;
    private _languages: Language[] = [
        { lang: 'en', name: 'English', flag: 'us' },
        { lang: 'pt', name: 'Portuguese', flag: 'br' },
    ];
    private defaultLanguage = this._languages[0];

    constructor(
        private translateService: TranslateService,
        private windowRefService: WindowRefService
    ) {
        this.window = this.windowRefService.window;
        this.currentLanguageSubject = new BehaviorSubject<Language>(undefined);
    }

    initialize() {
        this.translateService.setDefaultLang(this.defaultLanguage.lang);
        this.setCurrentLanguage(this.getClientDefaultLanguage());
    }

    setCurrentLanguage(target: Language) {
        const language = target
            ? this.languages.find((current) => current.lang === target.lang) ?? this.defaultLanguage
            : this.defaultLanguage;

        this.translateService.use(language.lang);
        moment.locale(language.lang);
        this.currentLanguageSubject.next(language);
    }

    private getClientDefaultLanguage(): Language {
        return this.languages.find(
            (language) => language.lang === this.window.navigator.language.substring(0, 2)
        );
    }
}
